module.exports = __webpack_public_path__ + "img/booking.3b8a776d.svg";